// MSA — Modern Sports & Athletics — mock data
// All data is mocked here so it can be replaced by backend later.

export const SITE = {
  brand: "MSA",
  full: "Modern Sports & Athletics",
  tagline: "Сучасний підхід до здоровʼя людей у русі",
  phone: "+380 (68) 384 45 95",
  phoneRaw: "+380683844595",
  // Одна адреса на весь сайт. Було чотири різні — у футері «м. Київ», у
  // структурованих даних Васильків, у самовивозі Васильків, у листах
  // Залізне. Google звіряє адресу з документами ФОП, і саме розбіжність
  // між ними — типова причина відмови. Підтверджено власницею 30.09.2026.
  city: "с. Залізне, Фастівський р-н, Київська обл.",
  addressFull: "08638, с. Залізне, Фастівський р-н, Київська обл., вул. Блакитна, 13",
  addressShort: "вул. Блакитна, 13, с. Залізне",
  hours: "9:00–19:00",
  instagram: "https://www.instagram.com/msa.sports.athletics?igsh=MWQ1ZDlkNjY4MGU5NQ%3D%3D&utm_source=qr",
  instagramHandle: "@msa.sports.athletics",
  telegram: "https://t.me/MSA_nutrition",
  telegramHandle: "@MSA_nutrition",
  tiktok: "https://www.tiktok.com/@msa.sports.athlet?_r=1&_t=ZS-96lKh8eij25",
  facebook: "https://www.facebook.com/share/1AtrshygsW/?mibextid=wwXIfr",
  email: "support@msa-sport.com.ua",
  freeShippingFrom: 2000,
  // ── FOP payment details (Реквізити для оплати на рахунок ФОП) ──
  fopName: 'ФОП Мотрич Юлія Володимирівна',
  fopIBAN: 'UA763052990000026001030145432',
  fopAccount: '26001030145432',
  fopBank: 'АТ КБ «ПриватБанк», м. Київ, Україна',
  fopEDRPOU: '3452007183',
  fopRNOKPP: '3452007183',
  fopAddress: '08638, с. Залізне, Фастівський р-н, Київська обл., вул. Блакитна, 13',
};

export const HERO_SLIDES = [
  {
    id: 1,
    title: "Енергія дня. Відновлення ночі.",
    subtitle:
      "Флагманська система AM / PM Multivitamins з хелатними мінералами — продумано під природні ритми тіла.",
    cta: "Дивитись систему",
    href: "/product/multivitamin-am-pm",
    image:
      "https://images.unsplash.com/photo-1572565408388-cdd3afe23e82",
    // Portrait 900x1000 crop (ratio 0.900) for the 343x380 mobile hero box, which
    // needs 686x760 at DPR 2. The desktop Unsplash shot is 3:2, so object-cover
    // used to upscale it ~1.5x on phones. Served from our own origin through
    // /api/image (AVIF + immutable cache) instead of a third-party CDN.
    mobileImage: "/uploads/msa-hero-swim-m1.jpg",
    align: "left",
    accent: "blue",
  },
  {
    id: 7,
    eyebrow: "Нова Пошта",
    title: "Безкоштовна доставка Новою Поштою",
    subtitle:
      "На всі комплекси AM / PM. Відправляємо щодня до 16:00 по всій Україні.",
    cta: "Обрати комплекс",
    href: "/product/multivitamin-am-pm",
    image: "/uploads/msa-delivery-hero.jpg",
    mobileImage: "/uploads/msa-delivery-hero-m2.jpg",
    align: "left",
    accent: "green",
  },
  {
    id: 2,
    title: "Хелатні мінерали: засвоюються краще",
    subtitle:
      "Магній, цинк, селен у формах, які тіло сприймає природно. Без перевантаження ШКТ.",
    cta: "До каталогу",
    href: "/catalog",
    image:
      "https://images.unsplash.com/photo-1512621776951-a57141f2eefd",
    align: "right",
    accent: "green",
  },
  {
    id: 3,
    title: "Безкоштовна доставка на товари MSA від 2000 грн",
    subtitle:
      "Відправляємо щодня до 16:00 по всій Україні Новою Поштою та Укрпоштою.",
    cta: "Умови доставки",
    href: "/payment-delivery",
    image:
      "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8",
    align: "left",
    accent: "blue",
  },
  {
    id: 4,
    title: "Lion's Mane: фокус і ясність думки",
    subtitle:
      "Екстракт їжовика гребінчастого — для тих, хто живе у режимі високого розумового навантаження.",
    cta: "Купити Lion's Mane",
    href: "/product/lions-mane",
    image:
      "https://images.unsplash.com/photo-1649345867132-e8bd35bedf76",
    align: "right",
    accent: "green",
  },
  {
    id: 5,
    title: "Omega-3: серце, мозок, суглоби",
    subtitle:
      "Концентрат Омега-3 у легких желатинових капсулах для щоденного раціону.",
    cta: "Замовити Omega-3",
    href: "/product/omega-3",
    image:
      "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b",
    align: "left",
    accent: "blue",
  },
  {
    id: 6,
    eyebrow: "Співпраця",
    title: "Розпочніть власний бізнес з MSA",
    subtitle: "Пропозиція співпраці для дропшиперів.",
    bullets: [
      "Прямі відправлення клієнту",
      "Повна технічна та маркетингова підтримка",
      "Відсутність необхідності у складі",
      "Проста інтеграція з платформами",
    ],
    cta: "Стати партнером MSA",
    href: "/contacts",
    image: "/uploads/msa-partner-hero-v5.jpg",
    mobileImage: "/uploads/msa-partner-hero-mobile-v5.jpg",
    align: "left",
    accent: "green",
  },
];

export const CATEGORIES = [
  { slug: "all", name: "Усі добавки", icon: "Sparkles" },
  { slug: "minerals", name: "Мінерали", icon: "Atom" },
  { slug: "vitamins", name: "Вітаміни", icon: "Sun" },
  { slug: "beauty", name: "Волосся, шкіра, нігті", icon: "Flower2" },
  { slug: "antioxidants", name: "Антиоксиданти", icon: "Shield" },
  { slug: "immunity", name: "Імунітет", icon: "ShieldCheck" },
  { slug: "joints", name: "Кістки та суглоби", icon: "Bone" },
  { slug: "energy", name: "Енергія та обмін", icon: "Zap" },
  { slug: "sleep", name: "Сон і стрес", icon: "Moon" },
  { slug: "gut", name: "Здоровʼя кишківника", icon: "Activity" },
  { slug: "brain", name: "Мозок і фокус", icon: "Brain" },
  { slug: "omega", name: "Омега та жири", icon: "Droplet" },
  { slug: "women", name: "Жіноче здоровʼя", icon: "Flower" },
  { slug: "detox", name: "Детокс", icon: "Leaf" },
  { slug: "liver", name: "Гепатопротекція", icon: "Sprout" },
  { slug: "kidneys", name: "Здоровʼя нирок", icon: "Droplets" },
  { slug: "thyroid", name: "Щитоподібна залоза", icon: "Stethoscope" },
  { slug: "eyes", name: "Очі та зір", icon: "Eye" },
  { slug: "kids", name: "Дитячі вітаміни", icon: "Baby" },
  { slug: "protein", name: "Протеїн", icon: "Milk" },
  { slug: "bcaa", name: "BCAA", icon: "Dumbbell" },
  { slug: "creatine", name: "Креатин", icon: "Flame" },
  { slug: "shakers", name: "Спортивні шейкери та пляшки", icon: "GlassWater" },
];

export const PRODUCTS = [
  {
    id: "multivitamin-am-pm",
    sku: "MSA0001",
    name: "Мультивітаміни та хелатні мінерали AM/PM",
    nameEn: "MULTIVITAMINS & CHELATED MINERALS AM/PM",
    price: 1490,
    oldPrice: 1690,
    inStock: true,
    badge: "Хіт",
    category: "vitamins",
    categories: ["vitamins", "minerals", "energy", "all"],
    image:
      "https://images.unsplash.com/photo-1763668331599-487470fb85b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHx2aXRhbWluJTIwc3VwcGxlbWVudCUyMGJvdHRsZXxlbnwwfHx8fDE3Nzc4OTQwMTh8MA&ixlib=rb-4.1.0&q=80&w=600",
    short:
      "Комплекс із двох формул для щоденної підтримки. Розроблено для чоловіків і жінок з урахуванням добових біоритмів. Енергія вдень. Відновлення ввечері.",
    benefits: [
      "Стабільний рівень енергії протягом дня",
      "Підтримка нервової системи та адаптація до стресу",
      "Гормональний баланс і відновлення",
      "Хелатні мінерали — максимальне засвоєння",
      "Розділення AM / PM під природні ритми",
    ],
    composition:
      "Зелена капсула (ранок): аскорбат натрію, екстракт маки перуанської, D-альфа-токоферолу ацетат, нікотинамід, кальцію D-пантотенат, піридоксину гідрохлорид, фолієва кислота, менахінон-7, біотин, ціанокобаламін, холекальциферол. Синя капсула (вечір): магнію бісгліцинат, L-теанін, цинку бісгліцинат, бору бісгліцинат, заліза бісгліцинат, марганцю бісгліцинат, міді бісгліцинат, хрому піколінат, молібдену бісгліцинат, селенометіонін.",
    use:
      "Дорослим по 2 капсули на добу: 1 зелену вранці під час їжі, 1 синю ввечері під час їжі.",
    form: "60 капсул у пластиковому контейнері",
    tags: ["AM/PM", "хелатні мінерали", "вітаміни"],
  },
  {
    id: "vitamin-d3-k2",
    sku: "MSA0002",
    name: "Вітамін D3 1000 МО + K2",
    nameEn: "VITAMIN D3 1000 IU + K2",
    price: 540,
    oldPrice: null,
    inStock: true,
    badge: "Рекомендуємо",
    category: "vitamins",
    categories: ["vitamins", "joints", "immunity", "all"],
    image:
      "https://images.unsplash.com/photo-1763668444855-401b58dceb20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHx2aXRhbWluJTIwc3VwcGxlbWVudCUyMGJvdHRsZXxlbnwwfHx8fDE3Nzc4OTQwMTh8MA&ixlib=rb-4.1.0&q=80&w=600",
    short:
      "Ефективна формула для підтримки здоровʼя кісток, зубів і серцево-судинної системи. Допомагає організму правильно засвоювати кальцій.",
    benefits: [
      "Сприяє зміцненню кісток і зубів",
      "Покращує засвоєння кальцію та фосфору",
      "Підтримує імунну систему",
      "Зменшує ризик відкладення кальцію в судинах",
    ],
    composition:
      "Оливкова олія, оболонка капсули, кокосова олія (MCT), менахінон-7, холекальциферол. 1 капсула: K2 — 50 мкг (67% РДН), D3 — 1000 МО (25 мкг). Сировина: Польща/Швейцарія.",
    use:
      "Дорослим 1–2 капсули на добу, дітям з 14-ти років по 1 капсулі на добу, під час їжі.",
    form: "30 мʼяких желатинових капсул",
    tags: ["D3", "K2", "кістки"],
  },
  {
    id: "lions-mane",
    sku: "MSA0003",
    name: "Екстракт їжовика гребінчастого",
    nameEn: "LION'S MANE EXTRACT",
    price: 890,
    oldPrice: null,
    inStock: true,
    badge: "Новинка",
    category: "brain",
    categories: ["brain", "immunity", "gut", "all"],
    image:
      "https://images.unsplash.com/photo-1763667926453-6a992d38ac43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxzdXBwbGVtZW50JTIwYm90dGxlfGVufDB8fHx8MTc3Nzg5NDAzMHww&ixlib=rb-4.1.0&q=80&w=600",
    short:
      "Природний засіб для роботи мозку, імунітету та відновлення. Стимулює ріст нервових клітин.",
    benefits: [
      "Покращує памʼять та концентрацію",
      "Допомагає при стресах і безсонні",
      "Активізує макрофаги і Т-лімфоцити",
      "Має протизапальну дію на ШКТ",
      "Знижує рівень холестерину та цукру в крові",
    ],
    composition:
      "Екстракт їжовика гребінчастого (Hericium erinaceus), оболонка капсули: желатин. Вміст однієї капсули 500 мг ± 9%.",
    use:
      "Дорослим по 2 капсули на добу під час прийому їжі.",
    form: "60 желатинових капсул у банці",
    tags: ["мозок", "фокус", "імунітет"],
  },
  {
    id: "omega-3",
    sku: "MSA0004",
    name: "Омега-3",
    nameEn: "OMEGA-3",
    price: 690,
    oldPrice: 790,
    inStock: true,
    badge: "Рекомендуємо",
    category: "omega",
    categories: ["omega", "joints", "brain", "all"],
    image:
      "https://images.unsplash.com/photo-1763668177859-0ed5669a795e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxzdXBwbGVtZW50JTIwYm90dGxlfGVufDB8fHx8MTc3Nzg5NDAzMHww&ixlib=rb-4.1.0&q=80&w=600",
    short:
      "Концентрат омега-3 поліненасичених жирних кислот рибʼячого жиру. Підтримка серця, мозку та суглобів.",
    benefits: [
      "Підтримує серцево-судинну систему",
      "Корисні жири EPA та DHA для мозку",
      "Сприяє роботі суглобів",
      "Підтримує здоровʼя шкіри",
    ],
    composition:
      "Концентрат омега-3 жирних кислот рибʼячого жиру, оболонка капсули: желатин, гліцерин, вода очищена. Вміст однієї капсули 500 мг.",
    use:
      "Дорослим по 2 капсули на добу під час прийому їжі.",
    form: "60 мʼяких желатинових капсул",
    tags: ["омега-3", "EPA", "DHA"],
  },
  {
    id: "magnesium-chelate",
    sku: "MSA0005",
    name: "Магній бісгліцинат хелат",
    nameEn: "MAGNESIUM CHELATE",
    price: 620,
    oldPrice: null,
    inStock: true,
    badge: null,
    category: "minerals",
    categories: ["minerals", "sleep", "energy", "all"],
    image:
      "https://images.unsplash.com/photo-1768403305881-a7a82fd63512?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxjYXBzdWxlcyUyMHBpbGxzfGVufDB8fHx8MTc3Nzg5NDAxOHww&ixlib=rb-4.1.0&q=80&w=600",
    short:
      "Хелатна форма магнію з амінокислотою гліцином — мʼяка дія на ШКТ і висока біодоступність.",
    benefits: [
      "Нервово-мʼязова підтримка",
      "Стресостійкість",
      "Якість сну та відновлення",
      "Не подразнює шлунок",
    ],
    composition: "Магнію бісгліцинат, оболонка капсули: желатин.",
    use: "Дорослим по 2 капсули на добу під час прийому їжі.",
    form: "60 капсул у банці",
    tags: ["магній", "хелат", "сон"],
  },
  {
    id: "zinc-chelate",
    sku: "MSA0006",
    name: "Цинк хелат комплекс",
    nameEn: "ZINC CHELATE",
    price: 410,
    oldPrice: null,
    inStock: true,
    badge: null,
    category: "minerals",
    categories: ["minerals", "immunity", "beauty", "all"],
    image:
      "https://images.pexels.com/photos/31406904/pexels-photo-31406904.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    short:
      "Цинк у формі бісгліцинату — для імунітету, шкіри та репродуктивного здоровʼя.",
    benefits: [
      "Підтримка імунної системи",
      "Здоровʼя шкіри та волосся",
      "Антиоксидантний захист",
      "Підтримка репродуктивного здоровʼя",
    ],
    composition: "Цинку бісгліцинат, оболонка капсули: желатин.",
    use: "Дорослим по 1 капсулі на добу.",
    form: "60 капсул у банці",
    tags: ["цинк", "імунітет"],
  },
  {
    id: "collagen-vitc",
    sku: "MSA0007",
    name: "Колаген + гіалуронова кислота + Vitamin C",
    nameEn: "COLLAGEN HYALURONIC ACID COMPLEX",
    price: 1290,
    oldPrice: null,
    inStock: true,
    badge: "Рекомендуємо",
    category: "beauty",
    categories: ["beauty", "joints", "all"],
    image:
      "https://images.pexels.com/photos/31406906/pexels-photo-31406906.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    short:
      "Колагенові пептиди з гіалуроновою кислотою та вітаміном С для шкіри, волосся, нігтів і суглобів.",
    benefits: [
      "Еластичність шкіри",
      "Здоровʼя суглобів",
      "Якість волосся та нігтів",
      "Антиоксидантна підтримка",
    ],
    composition:
      "Гідролізовані колагенові пептиди, гіалуронова кислота, вітамін С.",
    use: "Дорослим по 2 капсули на добу.",
    form: "90 капсул у банці",
    tags: ["колаген", "гіалуронка", "vitC"],
  },
  {
    id: "b-complex",
    sku: "MSA0008",
    name: "Комплекс вітамінів групи B",
    nameEn: "B-VITAMIN COMPLEX",
    price: 590,
    oldPrice: null,
    inStock: true,
    badge: "Новинка",
    category: "vitamins",
    categories: ["vitamins", "energy", "all"],
    image:
      "https://images.unsplash.com/photo-1592323818181-f9b967ff537c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxkaWV0YXJ5JTIwc3VwcGxlbWVudHN8ZW58MHx8fHwxNzc3ODk0MDE4fDA&ixlib=rb-4.1.0&q=80&w=600",
    short:
      "Повний спектр вітамінів групи B для нервової системи, обміну речовин і рівня енергії.",
    benefits: [
      "Підтримка нервової системи",
      "Енергія та витривалість",
      "Метаболізм білків і вуглеводів",
      "Здоровʼя крові",
    ],
    composition:
      "B1, B2, B3 (нікотинамід), B5, B6, B7 (біотин), B9 (фолієва кислота), B12.",
    use: "Дорослим по 1 капсулі на добу.",
    form: "60 капсул у банці",
    tags: ["B-complex", "енергія"],
  },
];

export const ARTICLES = [
  {
    id: "vitamin-combinations",
    title: "Як поєднувати між собою вживання вітамінів",
    excerpt:
      "Деякі речовини підсилюють дію одна одної, інші заважають засвоєнню. Принципи грамотного поєднання.",
    date: "12 березня 2025",
    readTime: "6 хв",
    cover:
      "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?w=1200&q=80&auto=format&fit=crop",
    body: [
      {
        h: "Чому важливо правильно комбінувати вітаміни",
        p: "Організм людини — це складна система, де поживні речовини взаємодіють між собою. Неправильне поєднання може викликати дефіцит мікроелементів і створити навантаження на органи (печінка, нирки).",
      },
      {
        h: "Вітаміни, які добре поєднуються",
        list: [
          "Вітамін D + кальцій — D допомагає засвоювати кальцій для зміцнення кісток і зубів.",
          "Вітамін C + залізо — C значно покращує засвоєння заліза, особливо з рослинних джерел.",
          "Вітаміни групи B — працюють у комплексі, підтримуючи нервову систему та обмін речовин.",
          "Вітамін A + жири — A є жиророзчинним, тому краще засвоюється з оліями, авокадо, горіхами.",
        ],
      },
      {
        h: "Що краще не поєднувати",
        list: [
          "Кальцій + залізо — кальцій знижує засвоєння заліза, краще з інтервалом 2–3 години.",
          "Магній + кальцій у великих дозах — конкурують за засвоєння.",
          "Цинк + мідь — надлишок цинку знижує рівень міді в організмі.",
        ],
      },
      {
        h: "Як правильно приймати",
        p: "Розділяйте прийом у часі. Жиророзчинні (A, D, E, K) — разом з їжею, що містить жири; водорозчинні (C, група B) — натщесерце або після їжі. Дотримуйтесь дозування й консультуйтесь із лікарем.",
      },
      {
        h: "Висновок",
        p: "Грамотне поєднання вітамінів — ключ до їх максимальної ефективності. Прості правила допоможуть уникнути помилок та підтримати здоровʼя на високому рівні.",
      },
    ],
  },
  {
    id: "chelated-minerals",
    title: "Хелатні мінерали: види, особливості та переваги",
    excerpt:
      "Хелатна форма — мінерал звʼязаний з амінокислотою чи органічною кислотою. Чому це працює краще за звичайні солі?",
    date: "5 березня 2025",
    readTime: "8 хв",
    cover:
      "https://images.unsplash.com/photo-1559757175-08c7765bf21d?w=1200&q=80&auto=format&fit=crop",
    body: [
      {
        h: "Що таке хелат",
        p: "Хелатний звʼязок (від грецького chele — «клешня») утворюється, коли органічна молекула «обхоплює» мінерал, формуючи стабільний комплекс. Ця форма активно використовується у харчових добавках і спортивному харчуванні.",
      },
      {
        h: "Ключові переваги",
        list: [
          "Краще засвоєння — організм сприймає хелат як «знайому» структуру.",
          "Менше навантаження на ШКТ — рідше викликають подразнення.",
          "Вища стабільність — менше взаємодій у шлунку.",
          "Краща ефективність при менших дозах.",
        ],
      },
      {
        h: "Види хелатних мінералів",
        list: [
          "Амінокислотні хелати (бісгліцинат магнію, піколінат цинку, гліцинат заліза) — найпоширеніший тип.",
          "Протеїнатні хелати — повільніше засвоюються, стабільніші у травленні.",
          "Органічні кислотні хелати (цитрат кальцію, малат магнію) — для чутливого травлення.",
          "Полісахаридні хелати — у функціональному харчуванні.",
        ],
      },
      {
        h: "Коли обирати хелати",
        p: "За дефіцитом мінералів, при підвищених навантаженнях, проблемах із засвоєнням, чутливому шлунку чи у періоди відновлення після хвороб.",
      },
    ],
  },
];
